export class FilePathModel {
    public constructor(public filePath: string) {}
}
